module.exports = __webpack_public_path__ + "img/mirror15.6eb293c8.jpg";